import React, { useState } from 'react';
import styled from 'styled-components';
import theme from 'styles/theme';
import LikeIcon from 'assets/icons/big_heart.svg';
import LikeBorderIcon from 'assets/icons/big_heart_border.svg';
import { useNavigate } from 'react-router-dom';
import useMarket from 'hooks/useMarket';

function MarketItem({ item }) {
   const CALL_AVAILABLE_TEXT = '문의가능';

   const { likeMarket, unlikeMarket, resetMarketDetailItem, resetMarketItems } = useMarket();

   const [isLike, setLike] = useState(item.is_liked === 1);
   const handleLike = e => {
      e.stopPropagation();

      if (isLike) {
         unlikeMarket({ wholeId: item.whole_id });
         setLike(false);
      } else {
         likeMarket({ wholeId: item.whole_id });
         setLike(true);
      }
      // if (isRegisteredUser) {
      //    if (isLike) {
      //       unlikeMarket({ wholeId: item.whole_id });
      //       setLike(false);
      //    } else {
      //       likeMarket({ wholeId: item.whole_id });
      //       setLike(true);
      //    }
      // } else {
      //    likeMarket({
      //       wholeId: item.whole_id,
      //    });
      //    setLike(true);
      // }
   };
   const navigate = useNavigate();

   const onNavigateToDetail = id => {
      resetMarketDetailItem();
      resetMarketItems();
      navigate(`/market/${id}`);
   };

   return (
      <MarketItemWrapper onClick={() => onNavigateToDetail(item.whole_id)}>
         {item.is_contact === 1 && <Badge>{CALL_AVAILABLE_TEXT}</Badge>}
         {item.is_liked !== undefined && (
            <LikeButton src={isLike ? LikeIcon : LikeBorderIcon} onClick={handleLike} />
         )}
         <MarketImage src={item.whole_img} />
         <MarketInfoWrap>
            <PlaceText>{item.market_type}</PlaceText>
            <MarketName>{item.whole_name}</MarketName>
            <Description>{item.whole_loc}</Description>
            {item.items_on_sale && (
               <TagsWrap>
                  {item.items_on_sale.map((tag, index) => {
                     return <Chip key={`${index}-${tag}`}>{tag}</Chip>;
                  })}
               </TagsWrap>
            )}
         </MarketInfoWrap>
      </MarketItemWrapper>
   );
}

export default MarketItem;

//common
export const Row = styled.div`
   display: flex;
   flex-direction: row;
   align-items: center;
`;
export const Column = styled.div`
   display: flex;
   flex-direction: column;
`;
export const Text = styled.p``;
export const Button = styled.button``;

//
const MarketItemWrapper = styled(Row)`
   cursor: pointer;
   user-select: none;
   position: relative;
   margin: 0px 16px;
   border: 1px solid #f1f3f5;
   box-shadow: 3px 3px 20px rgba(34, 37, 41, 0.05);
   border-radius: 8px;
`;

const MarketImage = styled.img`
   aspect-ratio: 1;
   width: 40%;
   object-fit: cover;
   border-top-left-radius: 8px;
   border-bottom-left-radius: 8px;
`;

const MarketInfoWrap = styled(Column)`
   box-sizing: border-box;
   width: 60%;
   justify-content: center;
   padding: 0px 8px 0px 16px;
`;

const PlaceText = styled(Text)`
   font-weight: 400;
   font-size: 12px;
   line-height: 20px;
   color: ${theme.color.gray700};
   margin-bottom: 2px;
`;

const MarketName = styled(Text)`
   font-weight: 700;
   font-size: 14px;
   line-height: 20px;
   margin-bottom: 4px;
`;

const Description = styled(Text)`
   font-weight: 400;
   font-size: 12px;
   line-height: 20px;
   color: ${theme.color.gray600};
   margin-bottom: 8px;
`;

const TagsWrap = styled(Row)`
   column-gap: 14px;
   row-gap: 6px;
   overflow-x: scroll;
   -ms-overflow-style: none;
   scrollbar-width: none;
   &::-webkit-scrollbar {
      display: none;
   }
`;
export const Chip = styled.div`
   background-color: #fff8f0;
   border-radius: 4px;
   font-weight: 400;
   font-size: 12px;
   line-height: 20px;
   color: ${theme.color.orange};
   padding: 0px 6px;
   white-space: nowrap;
`;

const LikeButton = styled.img`
   position: absolute;
   top: 12px;
   right: 12px;
   width: 22px;
   height: 22px;
   cursor: pointer;
`;

const Badge = styled.div`
   position: absolute;
   top: 6px;
   left: 6px;
   background-color: ${theme.color.orange};
   padding: 0px 3px;
   color: ${theme.color.white};
   font-weight: 600;
   font-size: 11px;
   line-height: 16px;
   border-radius: 4px;
`;
